import { EventsCarousel, HalfImgHero, StickyScroll } from "../blocks"
import { SweepsBanner } from "../Banner"

export const NascarPage = () => {
    return(<>
        <HalfImgHero
            bgimg="/static/images/refresh/2025/nascar-hero.jpg"
            content={[
                {bodyBase: 'As a proud partner of NASCAR®, Xumo makes it easy to stay on top of the action by putting racing season front and center with our smart TVs, streaming devices and the NASCAR Channel streaming free on Xumo Play.'}
            ]}
            nascarLogo={true}
            bannerActive={true}
        />
        <SweepsBanner />
        <StickyScroll
            bg="#F6F8F9"
            flipped={false}
            textbox={false}
            alignText="left"
            mobileCenter={true}
            sectionClass="pt-0 pb-8 lg:pt-48 lg:pb-36"
            itemWrapperClass="lg:-mb-[5vh] xl:-mb-[0vh]"
            content={[
                [
                    {
                        image: {
                        src: '/static/images/refresh/2025/icon-microphone.svg',
                        alt: 'microphone',
                        width: 400,
                        height: 400,
                        renderedHeight: 90,
                        },
                    },
                    { headingAlt: 'Just say <strong>“NASCAR”</strong>' },
                    {
                    subheadingAlt: 'Keep up with races, highlights and more on our dedicated destination featuring content from different apps and channels, all in one place. Just say “NASCAR” to explore it all the easy way with Xumo’s voice remote.',
                    },
                    {
                        ctaRow: [
                        {
                            href: '/products/xumo-tv',
                            label: 'Get a Xumo TV',
                            color: 'xumoAltBerryLight',
                            light: false,
                            primary: true,
                        },
                        {
                            href: '/products/xumo-stream-box',
                            label: 'Get a Xumo Stream Box',
                            color: 'xumoAltBerryLight',
                            light: false,
                            secondary: true,
                        },
                        ],
                    },
                ],
                [
                    {
                        image: {
                        src: '/static/images/refresh/2025/xumo-play-logo.png',
                        alt: 'xumo play',
                        width: 400,
                        height: 400,
                        renderedHeight: 90,
                        },
                    },
                    { headingAlt: 'Stream the NASCAR Channel — <strong>free, 24/7</strong>' },
                    {
                    subheadingAlt:
                        'Can’t get enough? Tune in to the NASCAR Channel on Xumo Play to watch classic races, documentaries, original shows and in-season replays, 24/7.',
                    },
                    {
                  ctaRow: [
                    {
                      href: 'https://play.xumo.com?',
                      label: 'Watch now',
                      target: '_blank',
                    },
                    {
                      image: {
                        src: '/static/images/refresh/2025/google-play.png',
                        alt: '',
                        height: 160 * (60 / 160),
                        width: 540 * (60 / 160),
                      },

                      href: 'https://play.google.com/store/apps/details?id=com.xumo.xumo',
                      label: 'Download on Google Play',
                      target: '_blank',
                    },
                    {
                      image: {
                        src: '/static/images/refresh/2025/app-store.png',
                        alt: '',
                        height: 160 * (60 / 160),
                        width: 480 * (60 / 160),
                      },
                      href: 'https://apps.apple.com/us/app/xumo-play-stream-tv-movies/id1068337978',
                      label: 'Download on Apple App Store',
                      target: '_blank',
                    },
                  ],
                },
                ],
            ]}
            images={[
                '/static/images/refresh/2025/say-nascar.png',
                '/static/images/refresh/2025/all-nascar-new.png'
            ]}
        />
        <EventsCarousel 
            bg="#F6F8F9"
            sectionClass="pb-24"
            title={[
                { heading: 'Meet us at <strong>the track</strong>'},
                {subheadingAlt: 'We’re bringing Xumo to NASCAR. Find our Easy Street Pit Stop at the following races.'}
            ]}
            items={[
                {
                    logo:{
                        src:"/static/images/refresh/2025/nascar-tracks/texas.png",
                        width:720,
                        height:356,
                    },
                    date: "2025/05/04",
                    month:"may",
                    day:"3–4",
                    trackname:"Texas Motor Speedway",
                    location:"Forth Worth, TX",
                    races:[
                        "Andy's Frozen Custard 300",
                        "Würth 400"
                    ]
                },
                {
                    logo:{
                        src:"/static/images/refresh/2025/nascar-tracks/north-wilkesboro.png",
                        width:720,
                        height:356,
                    },
                    date: "2025/05/18",
                    month:"may",
                    day:"18",
                    trackname:"North Wilkesboro Speedway",
                    location:"North Wilkesboro, NC",
                    races:[
                        "NASCAR All-Star Race"
                    ]
                },
                {
                    logo:{
                        src:"/static/images/refresh/2025/nascar-tracks/atlanta.png",
                        width:720,
                        height:320,
                    },
                    date: "2025/06/28",
                    month:"jun",
                    day:"27–28",
                    trackname:"Atlanta Motor Speedway",
                    location:"Hampton, GA",
                    races:[
                        "Focused Health 250",
                        "Quaker State 400"
                    ],
                    cta:{
                        href: "/press/xumo-brings-simpler-streaming-to-race-fans-in-atlanta",
                        color: 'xumoAltBerryLight',
                    }
                },
                {
                    logo:{
                        src:"/static/images/refresh/2025/nascar-tracks/chicago.png",
                        width:720,
                        height:320,
                    },
                    date: "2025/07/06",
                    month:"jul",
                    day:"5–6",
                    trackname:"Chicago Street Course",
                    location:"Chicago, IL",
                    races:[
                        "The Loop 110",
                        "Grant Park 165"
                    ],
                    cta:{
                        href: "/press/nascar-chicago-street-race-2025-recap-racing-live-music-drones-and-streaming-with-xumo",
                        color: 'xumoAltBerryLight',
                    }
                },
                {
                    logo:{
                        src:"/static/images/refresh/2025/nascar-tracks/bristol.png",
                        width:720,
                        height:320,
                    },
                    date: "2025/09/13",
                    month:"sep",
                    day:"12–13",
                    trackname:"Bristol Motor Speedway",
                    location:"Bristol, TN",
                    races:[
                        "Food City 300",
                        "Bass Pro Shops Night Race"
                    ]
                },
                {
                    logo:{
                        src:"/static/images/refresh/2025/nascar-tracks/las-vegas.png",
                        width:720,
                        height:320,
                    },
                    date: "2025/10/12",
                    month:"oct",
                    day:"11–12",
                    trackname:"Las Vegas Motor Speedway",
                    location:"Las Vegas, NV",
                    races:[
                        "Focused Health 302",
                        "South Point 400"
                    ]
                },
                {
                    logo:{
                        src:"/static/images/refresh/2025/nascar-tracks/phoenix.png",
                        width:720,
                        height:320,
                    },
                    date: "2025/11/02",
                    month:"nov",
                    day:"1–2",
                    trackname:"Phoenix Raceway",
                    location:"Phoenix, AZ",
                    races:[
                        "NASCAR Xfinity Series Championship Race",
                        "NASCAR Cup Series Championship"
                    ]
                },
            ]}
        />
    </>)
}